import { render, staticRenderFns } from "./OptionsSurvey.vue?vue&type=template&id=f547e0ee&scoped=true"
import script from "./OptionsSurvey.vue?vue&type=script&lang=ts"
export * from "./OptionsSurvey.vue?vue&type=script&lang=ts"
import style0 from "./OptionsSurvey.vue?vue&type=style&index=0&id=f547e0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f547e0ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VIcon})
